export default __webpack_public_path__ + "static/media/125.bad62182.jpg";